<div *ngIf="isBannerVisible" class="mobile-app-banner" [ngClass]="mobileDeviceOS">
  <div class="mobile-app-banner-container">
    <button type="button" class="mobile-app-banner-close" (click)="hideBanner()">&times;</button>

    <span class="mobile-app-banner-image"></span>

    <div class="mobile-app-info">
      <div class="mobile-app-title">
        {{ 'MOBILE_APP_BANNER.title' | translate }}
      </div>

      <div class="mobile-app-heading">
        {{ 'MOBILE_APP_BANNER.heading' | translate }}
      </div>
    </div>

    <div class="mobile-app-banner-wrapper">
      <a [href]="appUrl" class="mobile-app-link" target="_blank">
        <span class="mobile-app-link-text">
          {{ 'MOBILE_APP_BANNER.button' | translate }}
        </span>
      </a>
    </div>
  </div>
</div>
